import React, { useState } from 'react';
import { Container, Paper, Box } from '@mui/material';
import ColegiadoTable from './ColegiadoTable';
import ColegiadoAdminForm from '../Admin/ColegiadoAdminForm';

const AdminColegiados = () => {
  const [modo, setModo] = useState('editar'); // solo usaremos edición
  const [formKey, setFormKey] = useState(Date.now());
  const [colegiadoEditando, setColegiadoEditando] = useState(null);

  const handleEdit = (colegiado) => {
    setModo('editar');
    setColegiadoEditando(colegiado);
    setFormKey(Date.now());
  };

  // Si tu formulario expone onCancel/onSuccess, puedes ocultarlo al finalizar:
  const handleCloseForm = () => {
    setColegiadoEditando(null);
    setFormKey(Date.now());
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ width: '100%', maxWidth: '100%', px: 0 }}
    >
      <Box sx={{ mt: 2, mb: 4, width: '100%' }}>
        {/* Formulario en edición */}
        {colegiadoEditando && (
          <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
            <ColegiadoAdminForm
              key={formKey}
              initialValues={colegiadoEditando}
              modo={modo}
            />
          </Paper>
        )}

        {/* ⚠️ Evita Paper anidado si ColegiadoTable ya tiene su propio Paper */}
        <ColegiadoTable onEdit={handleEdit} />

        {/* Si quieres mantener un Paper externo, usa sx, no width= */}
        {/* 
      <Paper sx={{ width: '100%', maxWidth: 'none', p: 0, overflow: 'hidden' }}>
        <ColegiadoTable onEdit={handleEdit} />
      </Paper>
      */}
      </Box>
    </Container>
  );
}

export default AdminColegiados;
